/**
 * 正则验证方法库
 */
export function regType (type) {
  let exp

  switch (type) {
    default:
      exp = new RegExp()
      break
    case 'number': // 纯数字
      exp = /^\d+$/gi
      break
    case 'email': // 邮箱
      exp = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/gi
      break
    case 'httpUrl': // HTTP/HTTPS URL
      exp = /^(http|https):\/\/([0-9a-z_!~*'()-]+\.)*(([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\.)([a-z]{2,6})((\/?)|(\/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+(\/?))$/gi
      break
    case 'telephone': // 手机
      exp = /^1[3456789]\d{9}$/gi
      break
    case 'phone': // 座机
      exp = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/gi
      break
    case 'imgData': // data-url图片
      exp = /^data:image\//gi
      break
    case 'money': // 金额
      exp = /^(\d+)((\.){1,1}(\d){1,2})?$/g
      break
  }

  return exp
}



// WEBPACK FOOTER //
// ./core/utils/regExp.js